import { render, staticRenderFns } from "./ContractStatisticsList.vue?vue&type=template&id=204a4ba0&scoped=true&"
import script from "./ContractStatisticsList.vue?vue&type=script&lang=js&"
export * from "./ContractStatisticsList.vue?vue&type=script&lang=js&"
import style0 from "./ContractStatisticsList.vue?vue&type=style&index=0&id=204a4ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a4ba0",
  null
  
)

export default component.exports